export const INIT = 'prevenx/sw/INIT'
export const UPDATE = 'prevenx/sw/UPDATE'
export const RELOAD = 'prevenx/sw/RELOAD'
